export default "__VITE_ASSET__BLg51SSL__"